export const noneGroupHeader = "A3YVjc";
export default {noneGroupHeader};